import './jquery.lazy.min.js';
//import './rSlider.js';
// import './bootstrap-slider.min.js';

/**
 *  @author Eugene Terentev <eugene@terentev.net>
 */
jQuery($ => {
    "use strict";
    const body = $('body');

    //show additional fields on sign up for collaborator
    const collaboratorCheckbox = $('#signupform-is_collaborator');
    collaboratorCheckbox.on('change', () => {
        if (collaboratorCheckbox.is(':checked')) {
            $('#signup-collaborator-fields').removeClass('hidden');
        } else {
            $('#signup-collaborator-fields').addClass('hidden');
        }
    });

    //show additional fields on sign up for company representative
    const companyCheckbox = $('#signupform-is_company');
    companyCheckbox.on('change', () => {
        if (companyCheckbox.is(':checked')) {
            $('#signup-company-fields').removeClass('hidden');
        } else {
            $('#signup-company-fields').addClass('hidden');
        }
    });

    //Change image view  for products/pages list
    body.on('click', '[data-imageView]', function () {
        $('.catalog-page__content').removeClass('loaded');
        $.ajax({
            'data': {
                'key': 'imageView',
                'value': $(this).data('imageview')
            },
            'dataType': 'json',
            'success': function () {
                location.reload();
            },
            'url': '/shop/preferences/set'
        });
    });

    //Change view type for products/pages list
    body.on('click', '[data-viewType]', function () {
        $('.catalog-page__content').removeClass('loaded');
        $.ajax({
            'data': {
                'key': 'viewType',
                'value': $(this).data('viewtype')
            },
            'dataType': 'json',
            'success': function () {
                location.reload();
            },
            'url': '/shop/preferences/set'
        });
    });

    body.on('change', 'select[data-preference]', function () {
        $('.catalog-page__content').removeClass('loaded');
        const $this = $(this);
        $.ajax({
            'data': {
                'key': $this.data('preference'),
                'value': $this.val()
            },
            'dataType': 'json',
            'success': function () {
                if ($this.data('preference') === 'productsPerPage') {
                    const [head, tail] = location.href.split('?');
                    if (!tail || !tail.length) {
                        return location.href = head;
                    }
                    const newTail = tail.split('&')
                        .filter(p => !p.startsWith('page='))
                        .join('&');
                    if (!newTail.length) {
                        return location.href = head;
                    }
                    return location.href = head + '?' + newTail;
                }
                return location.reload();
            },
            'url': '/shop/preferences/set'
        });
    });
    
    body.on('change', '#customfilter-url', function (e) {
        if($(this).val()) return location.href = window.location.origin + $(this).val();
    });

    // Add products to cart
    body.on('click', '[data-action="addToCart"]', function(e) {
        e.preventDefault();
        var $this = $(this);
        var quantityInput = $('#quantity-product-' + $this.data('id'));
        if(quantityInput.val()==''){
            quantityInput.val(1);
        }
        var quantity = parseInt(quantityInput.val());
        if(!$(e.target).hasClass('master-product-add-to-cart')) {
            checkQuantity($this.data('id'));
        }
        /*
        if (isNaN(quantity) || quantity <= 0 || typeof(quantity) == 'undefined') {
            var modalWindowMin = $('#alert-validate-quantity-products-min');
            modalWindowMin.modal('show');
            setTimeout(() => modalWindowMin.modal('hide'), 5000);
            return false;
        }
        if(quantity > parseInt(quantityInput.attr('data-max-quantity'))){
            var modalWindowMax = $('#alert-validate-quantity-products-max');
            modalWindowMax.modal('show');
            setTimeout(() => modalWindowMax.modal('hide'), 5000);
        }*/

        var product = {
            'id' : $this.data('id'),
            'quantity' : quantity
        };
        quantityInput.val(quantity);

        $.ajax({
            'data' : {'products': [product]},
            'dataType' : 'json',
            'success' : function(data) {
                $('.jsCartItemsCount').text(data['itemsCount']);
                $('.jsCartItemsCountText').text(data['itemsCountText']);
                $('.jsOrderFullPrice').text(data['fullPrice']);
                $('.jsOrderFullWeight').text(data['itemsWeight']);
                $('#cartWidget').removeClass('emptyCartWidget');
                $('.cart-widget-short-w').removeClass('emptyCartWidget');

                $('.wrap-cart-widget-info').replaceWith($(data['cart_widget_template']).find('.wrap-cart-widget-info'));
                $('.page-cart').replaceWith($(data['cart_template']).filter('.page-cart'));

                if(data.errors){
                    var _err='';
                    $.each(data.errors,function(key,val){
                        $.each(val,function(k,_val){
                            _err+=_val+'<br/>';
                        })

                    })

                    if(!$(e.target).hasClass('master-product-add-to-cart')) {
                        $('#alert-validate-quantity-products-max .modal-body').html(_err);
                    }
                    return false;
                }
            },
            'type' : 'post',
            'url' : '/shop/cart/add'
        });
    });

    // Remove products from cart
    body.on('click', '[data-action="removeFromCart"]', function() {
        var $this = $(this),
            orderItemId = $this.data('id');
        if (orderItemId ) {
            $.ajax({
                'data' : {'id': orderItemId},
                'dataType' : 'json',
                'success' : function(data) {
                    $('.jsCartItemsCount').text(data['itemsCount']);
                    $('.jsCartItemsCountText').text(data['itemsCountText']);
                    $('.jsOrderFullPrice').text(data['fullPrice']);
                    if (typeof reloadGrid == 'function'){
                        reloadGrid();
                    }else{
                        $('[data-order-item-id="' + orderItemId + '"]').remove();
                    }

                    $('.wrap-cart-widget-info').replaceWith($(data['cart_widget_template']).find('.wrap-cart-widget-info'));
                    $('.page-cart').replaceWith($(data['cart_template']).filter('.page-cart'));
                    //$('.cart-widget-message-empty').replaceWith($(data['cart_widget_template']).find('.cart-widget-message-empty'));
                    if(parseInt(data['itemsCount']) == 0){
                        $('#cartWidget').addClass('emptyCartWidget');
                        $('.cart-widget-short-w').addClass('emptyCartWidget');
                        $('[data-action="saveOrder"], [data-action="sendFormCheckout"]').attr('disabled', true);
                        $('.jsGoToOrderPage').attr('onclick', 'return false').addClass('disabled');
                    }
                },
                'type' : 'post',
                'url' : '/shop/cart/delete?id=' + orderItemId
            });
        }
    });

    // Remove NonStandard products from cart
    body.on('click', '[data-action="removeFromCartNonSt"]', function() {
        var $this = $(this),
            orderItemId = $this.data('id');
        if (orderItemId ) {
            $.ajax({
                'data' : {'id': orderItemId},
                'dataType' : 'json',
                'success' : function(data) {
                    $('.jsCartItemsCount').text(data['itemsCount']);
                    $('.jsCartItemsCountText').text(data['itemsCountText']);
                    $('.jsOrderFullPrice').text(data['fullPrice']);
                    $('[data-order-item-nonstandard-id="' + orderItemId + '"]').remove();
                    if (typeof recalc == 'function'){
                        recalc();
                    }
                    $('.wrap-cart-widget-info').replaceWith($(data['cart_widget_template']).find('.wrap-cart-widget-info'));
                    $('.page-cart').replaceWith($(data['cart_template']).filter('.page-cart'));
                    if(parseInt(data['itemsCount']) == 0){
                        $('#cartWidget').addClass('emptyCartWidget');
                        $('.cart-widget-short-w').addClass('emptyCartWidget');
                        $('[data-action="saveOrder"], [data-action="sendFormCheckout"]').attr('disabled', true);
                        $('.jsGoToOrderPage').attr('onclick', 'return false').addClass('disabled');
                    }
                },
                'type' : 'post',
                'url' : '/shop/cart/delete-non-standard?id=' + orderItemId
            });
        }
    });
    // Remove Countertop products from cart
    body.on('click', '[data-action="removeFromCartCountertop"]', function() {
        var $this = $(this),
            orderItemId = $this.data('id');
        if (orderItemId ) {
            $.ajax({
                'data' : {'id': orderItemId},
                'dataType' : 'json',
                'success' : function(data) {
                    $('.jsCartItemsCount').text(data['itemsCount']);
                    $('.jsCartItemsCountText').text(data['itemsCountText']);
                    $('.jsOrderFullPrice').text(data['fullPrice']);
                   $('[data-order-item-nonstandard-id="' + orderItemId + '"]').remove();
                    $('.wrap-cart-widget-info').replaceWith($(data['cart_widget_template']).find('.wrap-cart-widget-info'));
                    $('.page-cart').replaceWith($(data['cart_template']).filter('.page-cart'));
                    if(parseInt(data['itemsCount']) == 0){
                        $('#cartWidget').addClass('emptyCartWidget');
                        $('.cart-widget-short-w').addClass('emptyCartWidget');
                        $('[data-action="saveOrder"], [data-action="sendFormCheckout"]').attr('disabled', true);
                        $('.jsGoToOrderPage').attr('onclick', 'return false').addClass('disabled');
                    }
                },
                'type': 'post',
                'url': '/shop/cart/delete-countertop?id=' + orderItemId
            });
            $(this).parents('.item').remove();
        }
    });

    body.on('click', '[data-action="sendFormCheckout"]', function (e) {
        //$(this).attr('disabled', 'disabled');
        $('.page-checkout').removeClass('loaded');
    });
    /*body.on('click', '[data-action="sendFormCheckout"]', function(e) {
        // e.preventDefault();
        // $(' [data-action="sendFormCheckout"]').attr('disabled', true);
        $('.page-checkout').removeClass('loaded');
        setTimeout(function () {
            // $(' [data-action="sendFormCheckout"]').attr('disabled', false);
            $('.page-checkout').addClass('loaded');
        }, 10000);

    });
*/
    body.on('click', '[data-action="clearCart"]', function() {
        $.ajax({
            'data' : {},
            'dataType' : 'json',
            'success' : function() {
                $('.jsCartItemsCount').text(0);
                $('.jsCartItemsCountText').text(0);
                $('.jsOrderFullPrice').text(0);
                $('.page-cart tbody tr:not(.jsCartRowFullPrice)').remove();
                $('#alert-empty-cart').modal('show').on('hide.bs.modal', function(){
                    history.back();
                });
            },
            'type' : 'post',
            'url' : '/shop/cart/clear'
        });
    });

    body.on('click', '[data-action="returnAssessment"]', function() {
        $.ajax({
            'data' : {},
            'dataType' : 'json',
            'success' : function(result) {
                if(result.in){
                    $.each(result.in,function(key,val){

                        $('[data-product-id="' + val.product_id + '"] .product-possible-produce').html(val.possible_to_create);
                        $('[data-product-id="' + val.product_id + '"] .product-possible-provide').html(val.possible_to_ensure);
                    });
                    $('.btnAssessment').hide();
                    $('.btnAssessment').removeAttr('disabled');
                    $('.btnCheckoutOrder').removeClass('hide');
                    $('.btnCheckoutOrder').show();
                }

                //$('.btnAssessment').removeClass('process');
                //$('#return-assessment .modal-body section').html(result);
                //$('#return-assessment').modal('show').on('hide.bs.modal', function(){
                //     history.back();
                //});
            },
            'beforeSend':function(){
                $('.btnAssessment').attr('disabled','disabled');
                //$('.btnAssessment').addClass('process');
            },
            'type' : 'post',
            'url' : '/shop/cart/assessment'
        });
    });

    $('body').on('click', '#btn-list-saved-orders-continue', function(e) {
        e.preventDefault();
        addItemsToExistOrder($('[name="order_id"]:checked').val());
    });


    function addItemsToExistOrder(orderId) {
        var currentOrderId=0;
        if($('[name="currentOrderId"]').length){
            currentOrderId=$('[name="currentOrderId"]').val();
        }
        const dataOrderItems = $('.checkbox-order-items:checked').serializeArray();
        dataOrderItems.push({name: 'current_order_id', value: currentOrderId});
        dataOrderItems.push({name: 'exist_order_id', value: orderId});
        if(!$('.checkbox-order-items:checked').length) {
            dataOrderItems.push({name: 'order_items[]', value: orderItemId});
        }

        $.ajax({
            type: 'POST',
            url: '/shop/cart/add-items-to-exist-order/',
            data: dataOrderItems,
            dataType: 'json',
            success: function (res) {
                if (res.redirect_to_exist_order) {
                    window.location = '/user/default/order-item?id=' + res.exist_order_id;
                } else {
                    if(currentOrderId!=0) {
                        res.order_items.forEach(function (item) {
                            $('.checkbox-order-items[value="' + item + '"]').closest('tr').remove();
                        });
                        $('#select-all-order-items').prop('checked', false);
                    }
                            //checkout
                            $('.page-cart').replaceWith($(res.cart_info['cart_template']).filter('.page-cart'));

                            //cart widget
                    $('.wrap-cart-widget-info').replaceWith($(res.cart_info['cart_widget_template']).find('.wrap-cart-widget-info'));

                    if(parseInt(res.cart_info['itemsCount']) == 0){
                        $('#cartWidget').addClass('emptyCartWidget');
                        $('.cart-widget-short-w').addClass('emptyCartWidget');
                        $('[data-action="saveOrder"], [data-action="sendFormCheckout"]').attr('disabled', true);
                        $('.jsGoToOrderPage').attr('onclick', 'return false').addClass('disabled');
                    }

                    $('.jsCartItemsCount').text(res.cart_info['itemsCount']);
                    // $('.jsCartItemsCountText').text(data['itemsCountText']);
                    $('.jsOrderFullPrice').text(res.cart_info['fullPrice']);
                    $('.jsOrderFullWeight').text(res.cart_info['itemsWeight']);
                    //$('#cartWidget').removeClass('emptyCartWidget');
                    //$('.cart-widget-short-w').removeClass('emptyCartWidget');


                    $('#list-saved-orders').modal('hide');
                    if (typeof res.message != 'undefined' && res.message) {
                        $('#warning-items-to-new-order .messages').html(res.message);
                        $('#warning-items-to-new-order').modal('show');
                    }

                }
            },
            error: function (e) {
                console.log('Error!', e);
            }
        });
    }

    function checkQuantity(ProductId) {
        var quantityInput = $('#quantity-product-' + ProductId);
        var quantity = parseInt(quantityInput.val());
        if (isNaN(quantity) || quantity <= 0 || typeof(quantity) == 'undefined') {
            var modalWindowMin = $('#alert-validate-quantity-products-min');
            modalWindowMin.modal('show');
            setTimeout(() => modalWindowMin.modal('hide'), 3000);
            return false;
        }
        if(quantity > parseInt(quantityInput.attr('data-max-quantity'))){
            var modalWindowMax = $('#alert-validate-quantity-products-max');
            modalWindowMax.modal('show');
            setTimeout(() => modalWindowMax.modal('hide'), 3000);
        }
    }

    // Change quantity products in cart
    function changeQuantityInCart(orderItemId, quantity){
        var data = {
            'id' : orderItemId,
            'quantity' : quantity
        };
        $.ajax({
            'data' : data,
            'dataType' : 'json',
            'success' : function(data) {
                $('.jsCartItemsCount').text(data['itemsCount']);
                $('.jsCartItemsCountText').text(data['itemsCountText']);
                $('.jsOrderFullPrice').text(data['fullPrice']);
                $('.jsOrderFullWeight').text(data['itemsWeight']);
                $('[data-order-item-id="' + orderItemId + '"] .jsOrderItemTotalPrice').text(data['itemTotalPrice']);
                $('[data-order-item-id="' + orderItemId + '"] .jsItemTotalWeight').text(data['itemTotalWeight']);
                if(data.warning) {
                    $('[data-order-item-id="' + orderItemId + '"] .product-warning').
                    html('<span style="color: red;font-size: 1.1em;padding-left: 5px;">*</span>');
                   var warning_list='';
                   var i=1;
                   $.each(data.warning ,function(key,val){
                       if(i>1)warning_list+='<br/>';
                       warning_list+=' <span style="margin-top: -25px;color: red;">';
                       for(var ii=0;ii<i;ii++){ warning_list+='*';}
                       warning_list+=' - '+val+'</span>';
                       i++;
                    })
                    $('.cart-warnings').html(warning_list);
                    $('.cart-warnings').removeClass('hide');
                }else{
                    $('[data-order-item-id="' + orderItemId + '"] .product-warning').html('');
                    $('.cart-warnings').addClass('hide');
                    $('.cart-warnings').html('');

                }
                $('.btnAssessment').show();
                $('.btnAssessment').removeClass('hide');
                $('.btnCheckoutOrder').hide();

            },
            'type' : 'post',
            'url' : '/shop/cart/change-quantity'
        });
    }
    body.on('change', '.packaging-product input[type=radio]', function() {
        var $input = $(this);
        var packaging = parseInt($input.val());
        var orderItemId = $input.closest('tr, .cart-page__single-product').data('order-item-id');
        var orderItemIdNonSt = $input.closest('tr, .cart-page__single-product').data('order-item-id');

        if (orderItemId){
            var data = {
                'id' : orderItemId,
                'packaging' : packaging
            };
            $.ajax({
                'data' : data,
                'dataType' : 'json',
                'success' : function(data) {
                    console.log(data);
                },
                'type' : 'post',
                'url' : '/shop/cart/change-package'
            });
        }
    });
    body.on('change', 'input[data-type=quantity]', function() {
        var $input = $(this);
        var quantity = parseFloat($input.val());
        var orderItemId = $input.closest('tr, .cart-page__single-product').data('order-item-id');
        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }
        changeQuantityInCart(orderItemId, quantity);
        $input.val(quantity);
    });
    body.on('click', '[data-action="changeQuantity"]', function() {
        var $this = $(this);
        var $input = $this.closest('.box-quantity-product').find('input[data-type=quantity]');
        var quantity = parseFloat($input.val());
        var orderItemId = $this.closest('.cart-page__single-product').data('order-item-id');
        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }
        if ($this.hasClass('plus')) {
            quantity += 1;
        } else {
            if (quantity > 1) {
                quantity -= 1;
            }
        }
        changeQuantityInCart(orderItemId, quantity);
        $input.val(quantity);
    });

    // изменение количества столешек
    body.on('click', '[data-action="changeQuantityTop"]', function() {
        var $this = $(this);
        var $input = $this.closest('.box-quantity-product').find('input[data-type=quantity]');
        var quantity = parseFloat($input.val());
        // var orderItemId = $this.closest('.cart-page__single-product').data('order-item-id');
        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }
        if ($this.hasClass('plus')) {
            quantity += 1;
        } else {
            if (quantity > 1) {
                quantity -= 1;
            }
        }
        // changeQuantityInCart(orderItemId, quantity);
        $input.val(quantity);
    });

    // Change view widget cart
    body.on('click', '[data-action="setFullViewCart"]', function() {
        $(this).addClass('hidden');
        $('#shortViewCart').addClass('hidden');
        $('[data-action="setShortViewCart"], #fullViewCart, .btnSaveOrder').removeClass('hidden');
    });
    body.on('click', '[data-action="setShortViewCart"]', function() {
        $(this).addClass('hidden');
        $('#fullViewCart, .btnSaveOrder').addClass('hidden');
        $('[data-action="setFullViewCart"], #shortViewCart').removeClass('hidden');
    });

    // Attempt to save an order with an unauthorized user
    body.on('click', '[data-action="alertMustLogin"]', function() {
        $('#cart-modal').modal('hide');
        $('#alert-must-login').modal('show');
    });

    // Show/ hide modals windows
   $('.btn-cart-show').click(function () {
       $('#cart-modal').modal('show');
       setTimeout(function () {
           $('.modal-backdrop.in').remove();
       }, 200);
   });

   $('.btnContinueShopping').click(function () {
       $('#cart-modal').modal('hide');
   });

    body.on('click','[data-target="#cart-modal"]',function () {
        $('.cart-widget-short-w').removeClass('active');
        setTimeout(function () {
            $('.modal-backdrop.in').remove();
        }, 200);
    });

   $('#cartWidget .btn-cart-modal').hover(function () {
       if(!$('.cart-block .cart-widget-short-w').hasClass('emptyCartWidget')){
           $('.cart-block .cart-widget-short-w').addClass('active');
       }
   },function () {
       setTimeout(function () {
           if(!$('.cart-block .cart-widget-short-w').is(":hover")){
               $('.cart-block .cart-widget-short-w').removeClass('active');
           }
       }, 200);
   });

    $('.cart-block .cart-widget-short-w').hover(function () {
        $(this).addClass('active');
    },function () {
        $(this).removeClass('active');
    });

    // Add order to user personal account in the saved orders section
    body.on('click', '[data-action="saveOrderWidgetCart"]', function() {
        $.ajax({
            'dataType' : 'json',
            'success' : function(data) {
                if(data['success']){
                    if (data['message']) {
                        $('#alert-save-order .modal-body').html(data['message']);
                    }
                    $('#cart-modal').modal('hide');
                    $('#alert-save-order').modal('show');
                    clearWidgetCart();
                }
            },
            'type' : 'post',
            'url' : '/shop/cart/save-order'
        });
    });

    function clearWidgetCart(){
        $('#cartWidget').addClass('emptyCartWidget');
        $('.cart-widget-short-w').addClass('emptyCartWidget');
        $('.jsCartItemsCount, .jsOrderFullPrice').text(0);
        // $('#fullViewCart tbody tr:not(.jsCartRowFullPrice)').remove();
        $('#fullViewCart .cart-page__single-product').remove();
    }

    body.on('click', '[data-action="saveOrder"]', function() {
        var data = {
            'orderId': $('#orderIdValue').val(),
            'payment_type_id': $('#checkoutform-payment_type_id').val(),
            'shipping_type_id': $('#checkoutform-shipping_type_id').val(),
            'comment': $('#checkoutform-comment').val()
        };
        $.ajax({
            'data' : data,
            'dataType' : 'json',
            'success' : function(data) {
                if(data['success']) {
                    if (data['message']) {
                        $('#alert-save-order .modal-body').html(data['message']);
                    }
                    $('#alert-save-order').modal('show').on('hide.bs.modal', function () {
                        window.location = '/';
                    });
                }
            },
            'type' : 'post',
            'url' : '/shop/cart/save-order'
        });
    });

    // Toggle view product properties in cart
    body.on('change', '[data-action="hideCartProductProperties"]', function() {
        $('.jsOrderProductProperties').slideToggle();
    });

    // Return to previous page to continue shopping
    body.on('click', '[data-action="returnBackPage"]', function () {
        history.back();
    });

    // Offer to login or register in page cart for unregistered users
    body.on('click', '[data-action="offerLoginOrRegister"]', function () {
        $('#offer-login-or-register').modal('show');
    });


    /**
     * вывод сообщения полсе валидации оформления заказа
     */
    $('#form-checkout').on('afterValidate', function (event, attribute, messages, deferreds) {
        $('#errors-widget').removeClass('has-error');
        $('#errors-widget').html('');
        $('[data-action="sendFormCheckout"]').removeAttr('disabled');

        //стандартные сообщения из yiiActiveForm
        if (messages.length) {
            $.each(attribute, function (k, msgarr) {
                //ищем объекты с ошибками и раскрываем родителей
                $.each(messages, function (key, obj) {
                    if (k == obj.id) {
                        $(obj.container).parent().closest('.shadow-widget').find('.title').addClass('open');
                    }
                })
                //блок всех ошибок
                if (msgarr.length) {
                    $('#errors-widget').addClass('has-error');
                    $.each(msgarr, function (id, msg) {
                        let newelem = document.createElement('p');
                        $(newelem).html(msg);
                        $('#errors-widget').prepend(newelem);
                    })
                }
            })
            $('.page-checkout').addClass('loaded');
        }

    })
    /* body.on('click', 'button.btnCheckoutOrder', function(e) {
		 $('#errors-widget').removeClass('has-error');
		 $('#errors-widget').html('');
		 setTimeout(function () {
			 var listErr = $('.form-group.has-error .help-block');
			 if (listErr.length > 0){
				 $('#errors-widget').addClass('has-error');
				 $('.page-checkout').addClass('loaded');

				 listErr.each(function(idx, item) {
					 let newelem  = document.createElement('p');
					 newelem.innerHTML = $(item).html();
					 $('#errors-widget').prepend( newelem );
				 });
			 }
		 }, 200);

	 });*/

    // Open window with info Privacy Policy
    body.on('click', '[data-action="openInfoPrivacyPolicy"]', function(e) {
        e.preventDefault();
        $('#info-privacy-policy').modal('show');
    });
    body.on('change', '[data-action="consentPrivacyPolicy"]', function() {
        if($(this).prop('checked')){
            $('.jsSendFormCheckout').attr('data-action', 'sendFormCheckout');
        } else {
            $('.jsSendFormCheckout').attr('data-action', 'alertAgreePrivacyPolicy');
        }
    });
    body.on('click', '[data-action="alertAgreePrivacyPolicy"]', function() {
        $('#alert-agree-privacy-policy').modal('show');
        return false;
    });

    // User authentication choices in page checkout
 /*   body.on('change', '.page-checkout [name="CheckoutForm[is_user_registered]"]', function() {
       if($(this).val() == 'registered'){
           $('#widget-login-form').modal('show').on('hide.bs.modal', function(){
               $('[value="not-registered"]').prop('checked', true);
           });
           $('.jsWrapFieldPassword').addClass('hidden');
       } else if($(this).val() == 'want-to-register'){
           $('.jsWrapFieldPassword').removeClass('hidden');
       } else {
           $('.jsWrapFieldPassword').addClass('hidden');
       }
    });
    */
    body.on('click', '.page-checkout [name="CheckoutForm[is_user_registered]"]', function() {
        if($(this).data('value') === 'userRegistered'){
            $('#widget-login-form').modal('show');
        } else if($(this).data('value') === 'userWantToRegistered'){
            $('#widget-signup-form').modal('show');
        }
    });


    body.on('click','#form_search .icon-search', function () {
        $('#searchform-q').submit();
    });

    body.on('click', ".dropdown-submenu>a", function(e) {
        if ($(this).parent().not(".open").length != 0){
            e.preventDefault();
        }
        //if ($('.rost-sidebar .nav .dropdown').hasClass('active')){
          //  $('.rost-sidebar .nav .dropdown').toggleClass('active');
        //}
        $( ".dropdown-submenu" ).removeClass("open");
        $(this).parents(".dropdown-submenu").toggleClass("open");
    });
    body.on('click', ".dropdown-submenu>span", function(e) {
        if ($(this).parent().not(".open").length != 0){
            e.preventDefault();
        }

        $( ".dropdown-submenu" ).removeClass("open");
        $(this).parents(".dropdown-submenu").toggleClass("open");
    });

    body.on('click','.a-search', function (e) {
        e.preventDefault();
        $('#searchform-q').submit();
    });

    $('.mobile-search-icon').click(function () {
        $( ".search-block" ).toggleClass('active');
    });

    //dynamic search as you type in a field searchform-q
    $("#searchform-q").keyup(function(e) {
        if($(this).val().length >2){

            var q = $("#form_search>form")
            $.ajax({
                type: $("#form_search>form").attr('method'),
                url: $("#form_search>form").attr('action'),
                data: q.serialize(),
                dataType: 'html',
                success: function (res) {
                    // console.log(res);
                    $('div.search-suggest>ul').remove();
                    $('div.search-suggest').prepend(res);
                    $('div.search-suggest').show();
                },
                error: function (e) {
                    console.log('Error!' + e);
                    // alert('Ajax response error! ' + e);
                }
            });
        }
    });

    //hiding dynamic search
    $(document).mouseup(function (e) { // событие клика по веб-документу
        var div = $(".search-suggest");
        var inp = $('#form_search');
        if (!inp.is(e.target) // если клик был не по нашему блоку
            && inp.has(e.target).length === 0) { // и не по его дочерним элементам
            div.hide();
        }
    });

    //add/remove class marked and cookies
    $($(document)).on('click touchstart','.favorite-product', function () {
        var id_prod = $(this).parents('.product-order-info, .product').find(".btn-add-to-cart").attr('data-id');
        if($(this).hasClass('marked')){
            $(this).removeClass('marked');
            changeCookiesFaviriteProduct('remove', id_prod);
        }else {
            $(this).addClass('marked');
            changeCookiesFaviriteProduct('add', id_prod);
        }
    });
    
    function changeCookiesFaviriteProduct(act, id_prod) {
        let data = {'act':act, 'id':id_prod};
        $.ajax({
            type: "POST",
            url: "/shop/product/favorite-product",
            data: {data:data},
            dataType: "json",
            success: function (res) {
                console.log(res);
            },
            error: function (e) {
                console.log('Error!' + e);
            }
        });
    }

    /*
    //  отменено 21/07/2021
    //Look more block
    body.on('click', '.catalog-load-more', function (e) {
        e.preventDefault();
        if ($(".catalog-load-more").hasClass('disabled')) {
            return;
        }
        var a_href = $('ul>li.next>a').attr('href');
        var html = $('.product-list').html();

        $.get(a_href, function (data) {

            var el = $("<div/>", {"html": data}).find('.product-list').html();
            $('.product-list').html(html + el);
            $('.catalog-page__progress-bar .heading span:first-child').text($('.product ').length);
            var ul_pagin_data = $("<ul/>", {"html": data}).find('.pagination-ul').html();
            $("ul.pagination-ul").replaceWith("<ul class=\"pagination-ul\" hidden>" + ul_pagin_data + "</ul>");

            if ($('ul>li.next').hasClass('disabled')) {
                $(".load-more-block").css('display','none');
            }
            $(".progress-bar-indicator").attr("style", "width:" + ($('.product ').length / $("span.total_count_prod").text() * 100) +"%");
        });
    });
    */

    if ( $('.pagination-ul').length == 0) {
        $(".load-more-block").css('display','none');
    }

    body.on('click', '.content_toggle', function(){
        $('.content_block').toggleClass('hide-text');
        if ($('.content_block').hasClass('hide-text')) {
            $('.content_toggle').removeClass('up');
            $('.content_toggle').addClass('down');
        } else {
            $('.content_toggle').removeClass('down');
            $('.content_toggle').addClass('up');
        }
        return false;
    });

    body.on('click', '.orders-load-more', function (e) {
        e.preventDefault();
        if ($(".orders-load-more").hasClass('disabled')) {
            return;
        }
        var a_href = $('ul>li.next>a').attr('href');
        var html = $('.order-rows').html();

        $.get(a_href, function (data) {

            var el = $("<div/>", {"html": data}).find('.order-rows').html();
            $('.order-rows').html(html + el);
            $('.orders-page__progress-bar .heading span:first-child').text($('.order-rows tr').length);
            var ul_pagin_data = $("<ul/>", {"html": data}).find('.pagination-ul').html();
            $("ul.pagination-ul").replaceWith("<ul class=\"pagination-ul\" >" + ul_pagin_data + "</ul>");

            if ($('ul>li.next').hasClass('disabled')) {
                $(".load-more-block").css('display','none');
            }
            $(".progress-bar-indicator").attr("style", "width:" + ($('.order-rows tr').length / $("span.total_count_orders").text() * 100) +"%");
        });
    });

    function movefilter() {
        if ($(window).width() > 767) {
            $('.rost-sidebar .catalog-menu__block').after($('#mobile-filter-id .filter-widget'));
        }else{
            $('#mobile-filter-id .modal-body').append( $('.rost-sidebar .filter-widget'));
            // close catalog-menu__block
            $('.rost-sidebar .catalog-menu__block .dropdown').removeClass('open');
        }
    }
    $( window ).resize(movefilter);
    movefilter();

//slick slider for product cart
//     $('.slider-for').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         fade: true,
//         dots: true,
//         asNavFor: '.slider-nav'
//     });
//     $('.slider-nav').slick({
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         asNavFor: '.slider-for',
//         centerMode: true,
//         focusOnSelect: true
//     });
//
// //slick slider for product cart modal
//     $('.show-modal').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: true,
//         infinite: true,
//         adaptiveHeight: true
//     });

    $('.product-show .img-part .product-img').click(function () {
        $('#product-show-modal').modal('show');
    });

    $('#product-show-modal').on('shown.bs.modal', function (e) {

        var max_h = window.innerHeight - 240;
        $(this).find('.product-img img').css('max-height',max_h + 'px');
        $('.show-modal').slick('setPosition');
        $('.show-modal').addClass('open');
    });

    //show modal widget-login-form
    $('.user-menu .login').click(function () {
        $('#widget-login-form').modal('show');
    });

    //show modal widget-signup-form
    $('.user-menu .registration').click(function () {
        $('#widget-signup-form').modal('show');
    });

    //show/hide button password
    $('body').on('click', '.password-control', function(){
        var input_pass = $(this).siblings('input');
        if (input_pass.attr('type') == 'password'){
            $(this).addClass('view');
            input_pass.attr('type', 'text');
        } else {
            $(this).removeClass('view');
            input_pass.attr('type', 'password');
        }
        return false;
    });
    // $('body').on('click', '.dropdown .dropbtn', function(){
    //     $(this).siblings('.dropdown-content').toggle("show");
    // });

    //select all order items
    $('#select-all-order-items').on('change', function() {
        if ($(this).prop('checked')) {
            $('.checkbox-order-items').prop('checked', true);
        } else {
            $('.checkbox-order-items').prop('checked', false);
        }
    });

    $($(document)).on('click', '.dropdown-filter-search .dropdown-filter-search-clean', function(e) {
        $(this).closest(".dropdown-menu").find('input:checkbox:checked').prop('checked', !1);
    }).on("keyup", ".dropdown-filter-search .dropdown-filter-search-field-box input", function() {
        DropdownFilterSearch_searchAndFilter($(this))
    });
    function DropdownFilterSearch_searchAndFilter(obj) {
        var value = obj.val().toLowerCase();
        obj.closest(".dropdown-menu").find('.filter-item-option').filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
        })
    }

    //перетянуть все модалки в боди
    $('body').append($('.rost-widget__modal'));

});
/*
// Window load event used just in case window height is dependant upon images
$(window).bind("load", function() {

    var footerHeight = 0,
        footerTop = 0,
        content = 0,
        $header = $('header'),
        $body = $('header ~ .rost-content'),
        $footer = $("footer.footer");

    positionFooter();

    function positionFooter() {

        footerHeight = $footer.height();
        footerTop = ($(window).scrollTop()+$(window).height()-footerHeight-$header.height())+"px";
        content = $header.height()+$body.height()+footerHeight;
        //$(document.body).height()+footerHeight)
        if ( content < $(window).height()) {
            $footer.css({
                position: "absolute"
            }).animate({
                top: footerTop
            })
        } else {
            $footer.css({
                position: "static"
            })
        }

    }

    $(window)
        .scroll(positionFooter)
        .resize(positionFooter)

});
*/
if ($('#doublescroll').length >0 ) {
    function DoubleScroll(element) {
        var scrollbar = document.createElement('div');
        scrollbar.appendChild(document.createElement('div'));
        scrollbar.style.overflow = 'auto';
        scrollbar.style.overflowY = 'hidden';
        scrollbar.firstChild.style.width = element.scrollWidth + 'px';
        scrollbar.firstChild.style.paddingTop = '1px';
        scrollbar.firstChild.appendChild(document.createTextNode(''));
        scrollbar.onscroll = function () {
            element.scrollLeft = scrollbar.scrollLeft;
        };
        element.onscroll = function () {
            scrollbar.scrollLeft = element.scrollLeft;
        };
        element.parentNode.insertBefore(scrollbar, element);
    }

    DoubleScroll(document.getElementById('doublescroll'));
}
$('#contactUsButtonMain').click(function (e) {
    $('body').toggleClass('show-overlay');
    $('#contactUsButtonList').toggleClass('active');
    $('#contactUsButtonMain').toggleClass('close');
    $('#mainButtonBlockImg').toggleClass('active');
    $('#mainButtonBlockCloseImg').toggleClass('hidden');
    $('#mainButtonBlockAnimtionItem1').toggleClass('circle-fill-animate');
    $('#mainButtonBlockAnimtionItem0').toggleClass('circlephone-animate');
});


$(document).on('click', '.delivery-widget .line', function (e) {
    $('.delivery-widget .view').removeClass('active');
    $(this).find('.view').addClass('active');

})

$(document).on('click', '.user-cab_analytics-page.delivery .company', function (e) {
    $(this).toggleClass('open');
    $('.user-cab_analytics-page.delivery .table .delivery').css('display', 'none');
    $('.user-cab_analytics-page.delivery .table .city').css('display','none');
    $('.user-cab_analytics-page.delivery .table .order').css('display','none');
    $('.user-cab_analytics-page.delivery .table .item').css('display','none');
    if($(this).hasClass('open')) {
        var key = $(this).data('key');
        $(this).siblings('.delivery-' + key).each(function (idx, item) {
            $(item).css('display', 'table-row');
        });
    }
}).on('click', '.user-cab_analytics-page.delivery .delivery', function (e) {
    $(this).toggleClass('open');
    $('.user-cab_analytics-page.delivery .table .city').css('display','none');
    $('.user-cab_analytics-page.delivery .table .order').css('display','none');
    $('.user-cab_analytics-page.delivery .table .item').css('display','none');
    if($(this).hasClass('open')) {
        var key = $(this).data('key');
        $(this).siblings('.city-' + key).each(function (idx, item) {
            $(item).css('display', 'table-row');
        });
    }
}).on('click', '.user-cab_analytics-page.delivery .city', function (e) {
    $(this).toggleClass('open');
    $('.user-cab_analytics-page.delivery .table .order').css('display','none');
    $('.user-cab_analytics-page.delivery .table .item').css('display','none');
    if($(this).hasClass('open')) {
        var key = $(this).data('key');
        $(this).siblings('.order-' + key).each(function (idx, item) {
            $(item).css('display', 'table-row');
        });
    }
}).on('click', '.user-cab_analytics-page.delivery .order', function (e) {
    $(this).toggleClass('open');
    $('.user-cab_analytics-page.delivery .table .item').css('display','none');
    if($(this).hasClass('open')) {
        var key = $(this).data('key');
        $(this).siblings('.item-' + key).each(function (idx, item) {
            $(item).css('display', 'table-row');
        });
    }
});
